module.exports = __webpack_public_path__ + "warning.7a3f95cec4b5847d44d1.svg";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/images/icon/warning.svg
// module id = ../../../../../src/assets/images/icon/warning.svg
// module chunks = styles